import { render, staticRenderFns } from "./productApprove-list.vue?vue&type=template&id=94b236ba&scoped=true"
import script from "./productApprove-list.vue?vue&type=script&lang=js"
export * from "./productApprove-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b236ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b236ba')) {
      api.createRecord('94b236ba', component.options)
    } else {
      api.reload('94b236ba', component.options)
    }
    module.hot.accept("./productApprove-list.vue?vue&type=template&id=94b236ba&scoped=true", function () {
      api.rerender('94b236ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/productApprove-management/productApprove-list.vue"
export default component.exports